import { enqueueSnackbar } from "notistack";

export const useSubmitAnswer = (
  assignmentQuestion,
  ApiClient,
  credentials = {},
) => {
  const submitAnswer = async (answer, identifier) => {
    try {
      const response = await ApiClient.assignment.submitAnswer({
        assignmentQuestion: assignmentQuestion.id,
        student: identifier.id,
        ...credentials,
        answer,
      });

      if (response.success) {
        enqueueSnackbar("Answer submitted!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(response.message || "Error submitting!", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to submit answer", error);
      enqueueSnackbar("Error submitting!", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return { submitAnswer };
};
